import { Award } from 'lucide-react';
import type { TrainingCertificate } from '../../../types';

interface CertificateCardProps {
    certificate: TrainingCertificate;
    courseTitle?: string;
}

export default function CertificateCard({ certificate, courseTitle }: CertificateCardProps) {
    const title = courseTitle || certificate.course?.title || 'Course Certificate';
    const issued = certificate.issuedAt
        ? new Date(certificate.issuedAt).toLocaleDateString(undefined, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
          })
        : '';

    return (
        <div className="relative overflow-hidden rounded-2xl border border-[#FF6B35]/30 bg-gradient-to-br from-[#14171A] to-[#1f242a] p-6 text-white">
            <div className="absolute -right-8 -top-8 h-40 w-40 rounded-full bg-[#FF6B35]/10 blur-2xl" />
            <div className="relative z-10">
                <div className="mb-4 flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#FF6B35]">
                        <Award className="h-6 w-6 text-white" />
                    </div>
                    <div>
                        <p className="text-xs uppercase tracking-wide text-gray-400">Certificate of Completion</p>
                        <p className="font-semibold">{title}</p>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4 text-sm md:grid-cols-3">
                    <div>
                        <p className="text-gray-400">Certificate No.</p>
                        <p className="font-mono font-medium">{certificate.certificateNumber}</p>
                    </div>
                    <div>
                        <p className="text-gray-400">Score</p>
                        <p className="font-medium text-[#FF6B35]">{certificate.score}%</p>
                    </div>
                    {issued && (
                        <div>
                            <p className="text-gray-400">Issued</p>
                            <p className="font-medium">{issued}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
